import { Configurator, ConfiguratorCategory, ConfiguratorOptionGroup, ConfiguratorPriceTable, ConfiguratorShop, ConfiguratorTag, OptionBase } from "#models/Configurator"
import { Shop } from "#models/Shop"
import * as Struct from "effect/Struct"
import { S } from "../../lib.ts"

export const SyncStatus = S.Literals(["UPDATED", "OUTDATED", "DISABLED"])
export type SyncStatus = typeof SyncStatus.Type

export class ShopRelation extends S.Opaque<ShopRelation, ShopRelation.Encoded>()(
  S
    .Struct({
      ...Struct.pick(Shop.fields, ["id", "name", "isEnabled", "swissMarket", "type"])
    })
    .annotate({ identifier: "ShopRelation" })
) {}

export class ConfiguratorShopView extends S.Opaque<ConfiguratorShopView, ConfiguratorShopView.Encoded>()(
  S
    .Struct({
      ...Struct.pick(ConfiguratorShop.fields, ["id", "syncEnabled", "magentoSku", "externalSku"]),
      syncStatus: SyncStatus,
      shop: ShopRelation
    })
    .annotate({ identifier: "ConfiguratorShopView" })
) {}

export const CategoryId = S.StringId

export class ConfiguratorCategoryView extends S.Opaque<ConfiguratorCategoryView, ConfiguratorCategoryView.Encoded>()(
  S
    .Struct({
      ...ConfiguratorCategory.fields
    })
    .annotate({ identifier: "ConfiguratorCategoryView" })
) {}

export class ConfiguratorTagView extends S.Opaque<ConfiguratorTagView, ConfiguratorTagView.Encoded>()(
  S
    .Struct({
      ...ConfiguratorTag.fields
    })
    .annotate({ identifier: "ConfiguratorTagView" })
) {}

export class ConfiguratorView extends S.Opaque<ConfiguratorView, ConfiguratorView.Encoded>()(
  S
    .Struct({
      ...Struct.omit(Configurator.fields, ["shops", "category"]),
      shops: S.Array(ConfiguratorShopView).withConstructorDefault,
      category: S.NullOr(ConfiguratorCategoryView).withConstructorDefault
    })
    .annotate({ identifier: "ConfiguratorView" })
) {}

export class ConfiguratorGeneralView extends S.Opaque<ConfiguratorGeneralView>()(
  S
    .Struct({
      ...Struct.pick(ConfiguratorView.fields, [
        "id",
        "category",
        "title",
        "isEnabled",
        "showerPreviewer",
        "dxfConfig",
        "basePrice",
        "priceId",
        "sortOrder",
        "shops",
        "category",
        "imageTemplate",
        "navigationBehavior",
        "swissMarket"
      ]),
      optionCount: S.NonNegativeInt
    })
    .annotate({ identifier: "ConfiguratorGeneralView" })
) {}

export class ConfiguratorListEntryView extends S.Opaque<ConfiguratorListEntryView>()(
  S
    .Struct({
      ...Struct.pick(ConfiguratorView.fields, ["id", "title", "isEnabled", "tagIds"]),
      categoryId: S.NullOr(CategoryId),
      createdAt: S.inputDate,
      lastEditedAt: S.inputDate
    })
    .annotate({ identifier: "ConfiguratorListEntryView" })
) {}

export class ConfiguratorOptionEntryView extends S.Opaque<ConfiguratorOptionEntryView>()(
  S
    .Struct({
      id: OptionBase["id"],
      name: OptionBase["name"]
    })
    .annotate({ identifier: "ConfiguratorOptionEntryView" })
) {}

export class ConfiguratorPriceTableEntryView extends S.Opaque<ConfiguratorPriceTableEntryView>()(
  S
    .Struct({
      ...Struct.pick(ConfiguratorPriceTable.fields, ["id", "name"])
    })
    .annotate({ identifier: "ConfiguratorPriceTableEntryView" })
) {}

export class ConfiguratorOptionGroupEntryView
  extends S.Opaque<ConfiguratorOptionGroupEntryView, ConfiguratorOptionGroupEntryView.Encoded>()(
    S
      .Struct({
        ...Struct.pick(ConfiguratorOptionGroup.fields, ["id", "name"])
      })
      .annotate({ identifier: "ConfiguratorOptionGroupEntryView" })
  )
{}

// codegen:start {preset: model}
//
export namespace ShopRelation {
  export interface Encoded extends S.StructNestedEncoded<typeof ShopRelation> {}
}
export namespace ConfiguratorShopView {
  export interface Encoded extends S.StructNestedEncoded<typeof ConfiguratorShopView> {}
}
export namespace ConfiguratorCategoryView {
  export interface Encoded extends S.StructNestedEncoded<typeof ConfiguratorCategoryView> {}
}
export namespace ConfiguratorTagView {
  export interface Encoded extends S.StructNestedEncoded<typeof ConfiguratorTagView> {}
}
export namespace ConfiguratorView {
  export interface Encoded extends S.StructNestedEncoded<typeof ConfiguratorView> {}
}
export namespace ConfiguratorOptionGroupEntryView {
  export interface Encoded extends S.StructNestedEncoded<typeof ConfiguratorOptionGroupEntryView> {}
}
//
// codegen:end
//
